import React, { useEffect, useState } from 'react';

const splashGif = `${process.env.PUBLIC_URL}/splash.gif`;

const SplashScreen = () => {
  const [show, setShow] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => setShow(false), 500);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-white transition-opacity duration-500 ease-in-out ${
        fadeOut ? 'pointer-events-none opacity-0' : 'opacity-100'
      }`}
    >
      <img
        src={splashGif}
        alt="Loading"
        className="h-auto w-[min(400px,150vw)] object-contain"
      />
    </div>
  );
};

export default SplashScreen;
